import { testMsg } from "../../test-apis";
import { isTestCompany } from "../../utils/auth";
import http from "../../utils/http";
import { toast } from "../../utils/toast";

// 계정과목 리스트 조회
export const getAccountingTitleList = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/accounting-titles/list", body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 계정과목 리스트 조회
export const getAccountingTitleUseList = (body) => {
  return new Promise((resolve, reject) => {
    http
      .post("/accounting-titles/use/list", body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 계정과목 사용항목 등록
export const createAccountingTitleUse = (accountingTitleIdx, body) => {
  return new Promise((resolve, reject) => {
    if (isTestCompany()) {
      testMsg()
      reject();
      return
    }
    http
      .post(`/accounting-titles/${accountingTitleIdx}/use`, body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 계정과목 수정
export const modifyAccountingTitle = (code, body) => {
  return new Promise((resolve, reject) => {
    if (isTestCompany()) {
      testMsg()
      reject();
      return
    }
    http
      .put(`/accounting-titles/${code}`, body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 계정과목 삭제
export const deleteAccountingTitle = (accountingTitleUseIdx) => {
  return new Promise((resolve, reject) => {
    if (isTestCompany()) {
      testMsg()
      reject();
      return
    }
    http
      .delete(`/accounting-titles/use/${accountingTitleUseIdx}`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};


//
// 검색 옵션 설정
//
export const getSettings = () => {
  return new Promise((resolve, reject) => {
    http
      .get("/accounting-titles/settings")
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const modifySettings = (body) => {
  return new Promise((resolve, reject) => {
    if (isTestCompany()) {
      testMsg()
      reject();
      return
    }
    http
      .put(`/accounting-titles/settings/add`, body)
      .then((res) => {
        toast.success('카테고리 검색 설정되었습니다.')
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
